<template>
    <Question
        :question="question"
        :answers="answers"
        @select="$emit('action', $event)"
        v-loading="isLoading"
    />
</template>

<script>
import Question from '../Question';

export default {
    name: 'CompletedView',
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
    data: () => ({
        question: 'Подтвердите освоенные компетенции и навыки.',
        answers: [
            // {
            //     key: 'redirect',
            //     text: 'Подтвердить',
            //     redirect: { name: 'account-competences' },
            // },
        ],
        isLoading: false,
    }),
    components: {
        Question,
    },
};
</script>

<style scoped lang="scss">
</style>